import { Record } from 'immutable';
import SourceApplication from 'automation-ui-canvas/data/records/SourceApplication';
import WorkflowsUser from 'automation-ui-canvas/data/records/WorkflowsUser';
export default Record({
  clonedFromWorkflowId: null,
  createdAt: null,
  createdByUser: new WorkflowsUser(),
  sourceApplication: new SourceApplication()
}, 'CreationSource');